module.exports = __webpack_public_path__ + "img/Flag_of_Sweden.c37f1b98.svg";